// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__SPpGw","buttonContainer":"style_buttonContainer__ftTJr","dividerContainer":"style_dividerContainer__T8zET"};